/**
 * The installed modules. Its own file so `ModulesProvider.tsx` exports only
 * components and the context, which keeps fast refresh working — the same
 * split as `auth/useAuth.ts`.
 */
import { useContext } from 'react';
import { ModulesContext } from './ModulesProvider';
import type { FrontendModule } from './types';

export function useModules(): readonly FrontendModule[] {
  return useContext(ModulesContext);
}
